module.exports = __webpack_public_path__ + "img/monthcard.6cde579c.png";